import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, ErrorStateMatcher } from '@angular/material';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';


export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

@Component({
  selector: "app-changestatedialog",
  templateUrl: "./changestatedialog.component.html",
  styleUrls: ["./changestatedialog.component.scss"]
})

export class ChangestatedialogComponent implements OnInit {

  currentStateFormControl = new FormControl('', [
    Validators.required
  ]);

  currentState: string;
  matcher = new MyErrorStateMatcher();

  
  constructor(public changeStateDialogRef: MatDialogRef<ChangestatedialogComponent>,  @Inject(MAT_DIALOG_DATA) public data: any) { 

  }

  ngOnInit() {

  }

  OnCloseConfirm(){
    if(!this.currentStateFormControl.errors) {
    this.changeStateDialogRef.close(this.currentState);
    }
  }

  OnCloseCancel(){
    this.changeStateDialogRef.close();
  }

}
